import { IResolvers, StatusbarDocument } from '@workbench-stack/core';

export const statusbarResolver: (services: any) => IResolvers = (services: any) => ({
    Query: {
        statusbarItem: (_, args, context) => {
            const { id } = args;
            const { statusbar } = context.client.readQuery({
                query: StatusbarDocument,
            });
            return statusbar.items.find((i) => i.id === id);
        },
    },
    Mutation: {
        addEntry: (_, args, context) => {
            const { arg } = args;
            services().statusbarService.addEntry(arg.entry, arg.id, arg.name, arg.alignment, arg.priority);
            return true;
        },
        removeStatusbarEntry: (_, args, context) => {
            const { id } = args;
            return services().statusbarService.removeStatusbarEntry(id);
        },
        updateStatusbarEntry: (_, args, context) => {
            const { arg } = args;
            return services().statusbarService.updateStatusbarEntry(arg.entry, arg.id, arg.alignment, arg.priority);
        },
        setStatusMessage: (_, args, context) => {
            const { arg } = args;
            return services().statusbarService.setStatusMessage(arg.id, arg.message);
        },
    },
} as IResolvers);
